export enum DeviceTypesEnum {
    None = -1, // This does not exist in the Backend Enum
    CompressorDevice = 1,
    Tank = 2,
    Well = 3,
    Generic = 4,
    CathodicProtectionSensor = 5,
    GasFlowMeter = 900,
    LiquidFlowMeter = 901,
    OilTank = 902,
    WaterTank = 903,
    PlungerController = 904,
    ESP = 905,
    PLC = 906,
    RodPump = 907,
    Separator = 908,
    Skimmer = 909,
    Platform = 910,
    Dehydrator = 911,
    ProducerWell = 912,
    InjectionWell = 913,
    Compressor = 914,
    TankBattery = 915,
    ChemicalInjectionController = 916,
    FuelGasMeter = 917,
    FlashGas = 918,
    OilMeter = 919,
    WaterMeter = 920,
    FlareGasMeter = 921,
    VRUGasMeter = 922,
    PowerMonitor = 923,
    GasMakeUpMeter = 924,
    GasLiftMeter = 925,
    MasterMeter = 926,
    LPSepGas = 927,
    HPSepGas = 928,
    SaleGas = 929,
    LPSalesGas = 930,
    HPSalesGas = 931,
    LPSalesCheckGas = 932,
    HPSalesCheckGas = 933,
    FlashOilMeter = 934,
    InletOilMeter = 935,
    WellOilMeter = 936,
    WellWaterMeter = 937,
    WellGasMeter = 938,
    WaterLeakDetection = 941,
    StandaloneTank = 954,

    InternalTank = 1000
}
